import { useState } from "react";
import "./header.css";
import Modal from "../modal/modal.tsx";
import type { ModalType } from "../modal/modal.tsx";

const Header = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState<ModalType>("methodology");

  const openModal = (type: ModalType) => {
    setModalType(type);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <header className="header-container">
        <nav className="header-nav">
          <div
            className="header-item header-item-with-background"
            onClick={() => openModal("methodology")}
          >
            Methodology
          </div>
          <div
            className="header-item header-item-with-background"
            onClick={() => openModal("howToUse")}
          >
            How to use the tool
          </div>
          <div
            className="header-item header-item-no-background"
            onClick={() => openModal("privacy")}
          >
            Privacy
          </div>
          <div
            className="header-item header-item-no-background"
            onClick={() => openModal("credits")}
          >
            Credits
          </div>
        </nav>
      </header>

      <Modal type={modalType} isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default Header;
